module.exports = __webpack_public_path__ + "static/img/icon-学生管理.b1d86e3d.png";